import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Checkbox, Input, message, Modal } from "antd";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import UserStore from "stores/UserStore";

const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            if (c.substring(name.length, c.length) === "undefined") {
                return '';
            }
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const GuestEmail = Form.create()(({form}) => {

    const {getFieldDecorator} = form;
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmit = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {

                const payload = {
                    email: values.email,
                    gclid: getCookie("gclid"),
                    fbclid: getCookie("_fbc")
                };

                setLoading(true);

                UserStore.saveLead(payload).then(data => {
                    UserStore.setGuestEmail(values.email);
                    history.push('quote');
                }).catch(err => {
                    if (err?.response?.status === 400) {
                        message.error("Invalid email address")
                    } else {
                        message.error("Error..")
                    }
                }).finally(() => setLoading(false))


            }
        })
    };


    return (

        <Form>
            <h3 style={{color: "red", fontWeight: 'bold'}}>Enter your email to get started</h3>
            <Form.Item className={"my-2"}>
                {getFieldDecorator('email', {
                    rules: [{required: true, message: "Email required"}, {type: "email"}],
                })(
                    <Input type={"email"} placeholder={"Email"} onPressEnter={handleSubmit}/>
                )}
            </Form.Item>

            <div className={"my-2"}>
                Do you have an Account? <Link className={"link"} to={"/login"}> Login </Link>
            </div>

            <Form.Item className={"my-2"}>
                {getFieldDecorator('terms', {
                    rules: [{
                        required: true, message: "Required"
                    }],
                    valuePropName: "checked"
                })(
                    <Checkbox> I am aware that all the information sent will be related to the email entered
                    </Checkbox>
                )}
            </Form.Item>


            <Button size="large" type="primary" onClick={handleSubmit}
                    loading={loading}>continue</Button>
        </Form>

    )
});
